var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"gf-profile-img",class:{'rounded': _vm.rounded},style:(_vm.style),attrs:{"src":_vm.profileImage,"alt":_vm.displayName}})}
var staticRenderFns = []

export { render, staticRenderFns }